import Vue from 'vue'
import { callTurnToConfigFn } from 'util/turnto-utils'
import chatterCommentsService from 'services/api/chatter-comments'
import chatterConfig from './chatter.config'
import domUtils from 'util/dom-utils'
import globalStore from 'init/global-store'
import CalloutComment from 'components/comment/callout-comment'
import MasonryLayout from 'layouts/masonry/layout'
import Pagination from 'objects/pagination/pagination'
import { RestError } from 'services/api-service'

import withRender from './chatter.html'
import './chatter.scss'


export default withRender(Vue.extend({
  data() {
    return {
      comments: [],
      currentPage: 1,
      globalStore,
      offset: 0,
      previousSku: '',
      total: 0
    }
  },
  components: {
    'tt-comment': CalloutComment,
    'tt-pagination': Pagination,
    'tt-masonry-layout': MasonryLayout
  },
  computed: {
    chatterConfig() {
      return chatterConfig
    },
    currentSku(): string {
      return this.globalStore.sku
    },
    limit() {
      return chatterConfig.limit
    }
  },
  methods: {
    fetchData() {
      if (this.currentSku && (this.offset === 0 || this.offset <= this.total)) {
        const isFirstCall = this.currentSku !== this.previousSku
        chatterCommentsService.chatterComments({
          sku: this.currentSku,
          offset: this.offset,
          limit: chatterConfig.limit,
          sort: chatterConfig.sortOrder as 0 | 1,
          minCharCount: chatterConfig.minCharacterCount,
          minWordCount: chatterConfig.minWordCount,
          includeSyndicated: chatterConfig.includeSyndicated,
          includeRelated: true
        }).then((data) => {
          this.previousSku = this.currentSku
          if (this.offset === 0 && data.comments.length < chatterConfig.minCount) {
            // not going to populate.  Does not meet the minimum comment count
            this.onFinish()
            return
          }
          this.comments = data.comments
          this.total = data.total
          this.$nextTick(() => {
            domUtils.whenRefIsVisible(this.$refs, 'layout').then(() => {
              // notify the layout that tiles have been added
              this.$refs.layout.$emit('tilesAdded')
            })
          })
          if (isFirstCall) {
            this.onFinish() // just need to call when initial comments are loaded
          }
        }).catch((e: RestError) => {
          // nothing necessary as widget won't show when there are no comments
        })
      }
    },
    onFinish() {
      this.$nextTick(() => { callTurnToConfigFn('chatter', 'onFinish') })
    },
    pageChange(pageNum) {
      if (pageNum === this.currentPage) {
        return
      }
      this.offset = chatterConfig.limit * (pageNum - 1)
      this.fetchData()
      this.currentPage = pageNum
    }
  },
  watch: {
    // whenever the currentSku changes, we need to reload the comments
    currentSku() {
      this.offset = 0
      this.currentPage = 1
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  }
}))
